// extracted by mini-css-extract-plugin
module.exports = {"commentLikeButtonSegment":"CommentLikeButton__commentLikeButtonSegment__JgXYy"};